import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface WarningBannerProps {
  message?: string;
  variant?: 'warning' | 'destructive';
}

export function WarningBanner({
  message = 'Cashero is experimental software in development. Do not deposit funds you cannot afford to lose. All operations are on Monero mainnet.',
  variant = 'destructive',
}: WarningBannerProps) {
  const colorClass = variant === 'destructive'
    ? 'border-red-500/50 bg-red-500/10'
    : 'border-yellow-500/50 bg-yellow-500/10';

  return (
    <Alert className={colorClass}>
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle className="text-sm font-semibold">⚠️ Testing Software</AlertTitle>
      <AlertDescription className="text-xs mt-1">
        {message}
      </AlertDescription>
    </Alert>
  );
}
